import { Icon } from '@/common/components/Icon'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui'

interface ActionsMenuProps {
  actions: {
    label: string
    icon?: JSX.Element
    onClick: () => void
  }[]
}

export const ActionsMenu = ({ actions }: ActionsMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          className="flex items-center gap-2.5 data-[state=open]:bg-gradient-6 border border-monochrome-1/20 [&_svg]:transition-transform [&_svg]:duration-200 data-[state=open]:[&_svg]:rotate-180"
        >
          <span className="text-white font-semibold text-button-m">
            Actions
          </span>
          <Icon
            icon="chevron-down"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            className="text-white"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-[242px] p-5 backdrop-blur-sm bg-monochrome-120 border-2 border-monochrome-120 divide-y divide-white/10 py-0">
        {actions.map((action) => (
          <DropdownMenuItem
            className="text-button-m p-3.5 text-monochrome-1 hover:opacity-70 focus:opacity-70 hover:bg-transparent focus:bg-transparent rounded-none px-0"
            key={action.label}
            onClick={action.onClick}
          >
            {action.icon && action.icon}
            <span>{action.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
